import { render, staticRenderFns } from "./Registrations.vue?vue&type=template&id=3aae5cda"
import script from "./Registrations.vue?vue&type=script&lang=ts"
export * from "./Registrations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports